module.exports = __webpack_public_path__ + "media/images/icons/rss-podcast-03f897b331fd5c747f6682386e71dd2a.svg";